// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectOtherJoineryQueryResult, selectOtherJoinerysPageLoading, selectOtherJoinerysShowInitWaitingMessage} from '../_selectors/other-joinery.selectors';

export class OtherJoinerysDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOtherJoinerysPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOtherJoinerysShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOtherJoineryQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
